import React from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactRouterProps,
  Redirect,
} from 'react-router-dom';

import PageLoader from '../components/PageLoader';
import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactRouterProps {
  isPrivate?: boolean;
  guestOnly?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  guestOnly = false,
  component: Component,
  ...rest
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (isPrivate && !user) {
          return (
            <Redirect
              to={{ pathname: '/login', state: { from: location } }}
            />
          );
        }

        if (guestOnly && user) {
          return (
            <Redirect
              to={{ pathname: '/', state: { from: location } }}
            />
          );
        }

        return <Component />;
      }}
    />
  );
};

export default Route;
